import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';
import { groupHours, todayKey } from '../helpers';
import type { OpeningHours } from '../types';

export function HoursList({ hours, timeZone }: { hours: OpeningHours; timeZone?: string }) {
  const { t } = useTranslation('bookingPage');
  const today = todayKey(new Date(), timeZone);
  const rows = groupHours(hours);

  return (
    <dl className="flex flex-col gap-2" data-testid="hours-list">
      {rows.map((row) => {
        const first = t(`hours.days.${row.days[0]}`);
        const last = t(`hours.days.${row.days[row.days.length - 1]}`);
        const isToday = row.days.includes(today);
        return (
          <div key={row.days.join('-')} className={cn('flex justify-between gap-4 text-body', isToday ? 'font-semibold text-ink' : 'text-soft')}>
            <dt>{row.days.length > 1 ? `${first} – ${last}` : first}</dt>
            <dd className="tabular-nums">{row.label ?? t('hours.closed')}</dd>
          </div>
        );
      })}
    </dl>
  );
}
